import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authServices from '../services/authServices';

type MenuItem = {
        title: string;
        link: string;
        onClick?: () => void;
    };

export enum sessionLogoutType {
    Logout = 'Logout',
    multipleSessionsFound = 'multipleSessionsFound',
    LogoutCurrentSession = 'LogoutCurrentSession',
    LogoutAllSessions = 'LogoutAllSessions',    
}

export interface AuthState {
    accessToken: string;
    refreshToken: string;
    sessionID?: string;
    userEntitlements?: IEntitlementResponse;
    entitledMenuItems?: MenuItem[];
    isScheduleListViewable?: boolean;
    isScheduleEditable?: boolean;
    isScheduleDeletable: boolean;
    isScheduleViewable?: boolean;
    isRateFinderViewable?: boolean;
    isRiskLocatorViewable?: boolean;
    isAdminOrgReadable?: boolean;
    isAdminOrgEditable?: boolean;
    isAdminDataReadable?: boolean;
    isAdminDataEditable?: boolean;
    isAdminRbacReadable?: boolean;
    isAdminRbacEditable?: boolean;
    userLogout?: boolean;
    userPopupMessage?: boolean;
}

const initialState: AuthState = {
    accessToken: '',
    refreshToken: '',
    sessionID: '',
    userEntitlements: undefined,
    entitledMenuItems: [],
    isScheduleListViewable: false,
    isScheduleViewable: false,
    isScheduleEditable: false,
    isScheduleDeletable: false,
    isRateFinderViewable: false,
    isRiskLocatorViewable: false,
    isAdminOrgReadable: false,
    isAdminOrgEditable: false,
    isAdminDataReadable: false,
    isAdminDataEditable: false,
    isAdminRbacReadable: false,
    isAdminRbacEditable: false,
    userLogout: false,
    userPopupMessage: false,
};

export interface IToken {
    accessToken: string;
    refreshToken: string;
    sessionID?: string;
}

export interface IEntitlementResponse {
data : {
    entitlements : {
        userId: string;
        userEmail: string;
        clientId: string;
        applications:{
            name: string,
          resources: [
            {
              resourceName: string,
              apiEndpoint: string,
              httpMethod: string,
              operation: string,
              entityName: string,
              allowedAreas: [
                {
                  countryCode: string,
                  regionId: string,
                  subRegionId: string,
                }
                  ]
        }
    ]
    },
}
}
}


export const getAuthToken = createAsyncThunk<string, IToken>('authSlice/get-auth-token', async (token: IToken) => {
    return authServices.getAuthTokenFromRefreshToken(token).then((res) => res);
});

export const getuserEntitlements = createAsyncThunk<IEntitlementResponse>('authSlice/get-tax-news', async () => {
    return authServices.getuserEntitlements().then((res) => res);
});

const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getAuthToken.fulfilled, (state, action: PayloadAction<string>) => {
                state.accessToken = action.payload;
            })
            .addCase(getAuthToken.rejected, (state) => {
                state.accessToken = '';
            })
            .addCase(getuserEntitlements.fulfilled, (state, action: PayloadAction<IEntitlementResponse>) => {
                state.userEntitlements = action.payload;
            });
    },
    reducers: {
        setTokens(
            state,
            action: PayloadAction<{
                accessToken: string;
                refreshToken: string;
                sessionID: string;
            }>,
        ) {
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            state.sessionID = action.payload.sessionID;
        },
        removeTokens(state) {
            state.accessToken = '';
            state.refreshToken = '';
            state.sessionID = '';
        },
        setUserLogout(state,action: PayloadAction<boolean>) {
            state.userLogout = action.payload;
        },
        setUserPopupMessage(state,action: PayloadAction<boolean>) {
            state.userPopupMessage = action.payload;
        },
        setUserEntitlements(state, action: PayloadAction<MenuItem[]>) {
            state.entitledMenuItems = action.payload;
        },
        setisScheduleListViewable(state, action: PayloadAction<boolean>) {
            state.isScheduleListViewable = action.payload;
        },
        setisScheduleEditable(state, action: PayloadAction<boolean>) {
            state.isScheduleEditable = action.payload;
        },
        setisScheduleDeletable(state, action: PayloadAction<boolean>) {
            state.isScheduleDeletable = action.payload;
        },
        setisScheduleViewable(state, action: PayloadAction<boolean>) {
            state.isScheduleViewable = action.payload;
        },
        setisRateFinderViewable(state, action: PayloadAction<boolean>) {
            state.isRateFinderViewable = action.payload;
        },
        setisRiskLocatorViewable(state, action: PayloadAction<boolean>) {
            state.isRiskLocatorViewable = action.payload;
        },
        setisAdminOrgReadable(state, action: PayloadAction<boolean>) {
            state.isAdminOrgReadable = action.payload;
        },
        setisAdminOrgEditable(state, action: PayloadAction<boolean>) {
            state.isAdminOrgEditable = action.payload;
        },
        setisAdminDataReadable(state, action: PayloadAction<boolean>) {
            state.isAdminDataReadable = action.payload;
        },
        setisAdminDataEditable(state, action: PayloadAction<boolean>) {
            state.isAdminDataEditable = action.payload;
        },
        setisAdminRbacReadable(state, action: PayloadAction<boolean>) {
            state.isAdminRbacReadable = action.payload;
        },
        setisAdminRbacEditable(state, action: PayloadAction<boolean>) {
            state.isAdminRbacEditable = action.payload;
        },
        setUserEntitlementsDefault(state){
            state.isScheduleListViewable = false;
            state.isScheduleViewable = false;
            state.isRateFinderViewable = false;
            state.isRiskLocatorViewable = false;
            state.isAdminOrgReadable = false;
            state.isAdminDataEditable = false;
        },

    },
});
export const { setTokens, removeTokens, setUserLogout,setUserPopupMessage, setUserEntitlements,setisScheduleEditable, setisScheduleListViewable,setUserEntitlementsDefault,
setisScheduleDeletable, setisScheduleViewable, setisRateFinderViewable, setisRiskLocatorViewable, setisAdminOrgReadable, setisAdminOrgEditable, setisAdminDataReadable, setisAdminDataEditable, setisAdminRbacReadable, setisAdminRbacEditable,
  } = authSlice.actions;

export default authSlice.reducer;
